import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [plan, setPlan] = useState('free');

  useEffect(() => {
    // Simulate auth check
    const storedUser = localStorage.getItem('coldmail_user');
    const storedPlan = localStorage.getItem('coldmail_plan');
    
    if (storedUser) {
      setUser(JSON.parse(storedUser));
      setPlan(storedPlan || 'free');
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    // Simulate login
    const userData = {
      id: 1,
      email,
      name: email.split('@')[0],
      avatar: `https://ui-avatars.com/api/?name=${email.split('@')[0]}&background=0AB6BC&color=fff`
    };
    
    setUser(userData);
    localStorage.setItem('coldmail_user', JSON.stringify(userData));
    return userData;
  };

  const signup = async (email, password, name) => {
    // Simulate signup
    const userData = {
      id: Date.now(),
      email,
      name,
      avatar: `https://ui-avatars.com/api/?name=${name}&background=0AB6BC&color=fff`
    };
    
    setUser(userData);
    localStorage.setItem('coldmail_user', JSON.stringify(userData));
    return userData;
  };

  const logout = () => {
    setUser(null);
    setPlan('free');
    localStorage.removeItem('coldmail_user');
    localStorage.removeItem('coldmail_plan');
  };

  const upgradePlan = (newPlan) => {
    setPlan(newPlan);
    localStorage.setItem('coldmail_plan', newPlan);
  };

  const value = {
    user,
    plan,
    loading,
    login,
    signup,
    logout,
    upgradePlan
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};